import { REST_METHOD, REST_URL } from '../constants';
import { requestAudit, requestM365, requestUser } from './api';

export async function saveDelegation(data:any, delegation_uid?: string) {
    try{
      const requestParams = {
        url: `${REST_URL.CMDB}${REST_URL.SAVE_DELEGATION}`,
        queryParams: {
          ...(delegation_uid ? { delegation_uid: delegation_uid } : {})
        },
        method: `${REST_METHOD.PUT}`,
        data: data
      };
      const response = await requestUser(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  };

export async function getDelegation(params: {
  user_uid: string;
  by?: string;
  valid_time?: boolean;
  approvals?: boolean;
}) {
  try {
    const requestParams = {
      url: `${REST_URL.CMDB}${REST_URL.GET_DELEGATION}`,
      method: REST_METHOD.GET,
      queryParams: {
        ...params,
      },
    };
    const response = await requestUser(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function sendEmail(data: any){
  try{
    const requestParams = {
      url: `${REST_URL.SEND_EMAIL}`,
      method: `${REST_METHOD.POST}`,
      data: data
    };
    const response = await requestM365(requestParams);
    return response;
  } catch(error) {
    throw error
  }
}

export async function createAuditLog(data: any){
  try {
    const requestParams = {
      url: `${REST_URL.AUDIT}${REST_URL.CREATE}`,
      method: `${REST_METHOD.POST}`,
      data: data
    };
    const response = await requestAudit(requestParams);
    return response;
    
  } catch (error) {
    throw error;
  }
}